import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import Pagination from '@material-ui/lab/Pagination';
import RestServices from '../services/RestServices.js';
import AddEdit from './AddEdit';
import StoretagProfileDetail from './StoretagProfileDetail';
import ImportExport from './ImportExport';
import ViewProfileDetail from '../Profile/ViewProfileDetail';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';

import { withFirebase } from '../Firebase';

const pageSizes = [5, 10, 25, 50, 100];
const lockStatusArray =[
    { key: 'Unlocked', value: 'Unlocked' },
    { key: 'Locked', value: 'Locked' },
]
const StoreTypeArray =[
    { key: 'Easy', value: 'Easy' },
    { key: 'Non-Easy', value: 'Non-Easy' },
]

const searchBy = [
    { key: 'Store Tag', value: 'StoreTag' },
    { key: 'Store Email', value: 'EmailId' },
    { key: 'Store-CP Name', value: 'StoreCPName' },
    { key: 'Store Owner Name', value: 'StoreOwnerName' },
    { key: 'Employee Name', value: 'EmployeeName' },
    { key: 'Distributor Name', value: 'DistributorName' },
    { key: 'Store City', value: 'City' },
    { key: 'Store District', value: 'District' },
    { key: 'Store Phone Number', value: 'PhoneNumber' },
    { key: 'Store Pin Code', value: 'PinCode' },
    { key: 'Store State', value: 'State' },
    { key: 'Store LockStatus', value: 'lock_status' },
    { key: 'Store Type', value: 'StoreType' }
];

class AllList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'StoreTag',

        viewProfile: false,
        UniqeID: '',
        viewProfileRole: '',
        profileFullName: '',
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        flag: true,
        showAdd: false,
        showEdit: false,
        StoreTag: '',
        showLocked: false
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({ flag: true, alert: 0 });
        }

        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        

        await RestServices.getStoreTagsMappingPaginate(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({ data: [] });
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    cancleAction = () => {
        this.loadData();
        if (this._isMounted) {
            this.setState({ showEdit: false, showAdd: false });
        }
    };

    cancleImportExport = () => {
        this.loadData();
        if (this._isMounted) {
            this.setState({ importExport: false });
        }
    };

    cancleviewProfile = () => {
        if (this._isMounted) {
            this.setState({ viewProfile: false });
        }
    };

    showViewProfile = (fullName, UserId, userRole) => {
        if (this._isMounted) {
            this.setState({
                profileFullName: fullName,
                viewProfileRole: userRole,
                UniqeID: UserId,
                viewProfile: true,
                showEdit: false,
                showAdd: false,
                manageMapping: false
            });
        }
    };

    showEditItem = (rowData) => {
        if (this._isMounted) {
            if (this._isMounted) {
                this.setState({
                    showEdit: true,
                    manageMapping: false,
                    selectedRow: rowData
                });
            }
        }
    };

    toggleBlockStatus = () => {
        if (this._isMounted) {
            this.setState({ showLocked: !this.state.showLocked });
            this.loadData();
        }
    };

    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({
                            showAdd: true,
                            manageMapping: false,
                            selectedRow: false
                        });
                    }
                }
            },
            {
                icon: 'import_export',
                tooltip: 'Import StoreTags',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({ importExport: true });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.importExport &&
                    !this.state.showAdd &&
                    !this.state.showEdit &&
                    !this.state.viewProfile && (
                        <div>
                            <Row>
                                <h4
                                    style={{
                                        marginLeft: '1rem',
                                        marginRight: '1rem'
                                    }}
                                >
                                    Manage Store Tags
                                </h4>
                            </Row>
                            <div>
                                <hr />
                            </div>

                            <Row style={{ justifyContent: 'right' }}>
                                <Col
                                    style={{
                                        justifyContent: 'right',
                                        textAlign: 'right'
                                    }}
                                >
                                    <Form.Group
                                        as={Row}
                                        style={{
                                            justifyContent: 'right',
                                            marginRight: '0'
                                        }}
                                    >
                                        <select
                                            className="form-control"
                                            style={{ width: 'auto' }}
                                            name="search_by"
                                            onChange={this.onChangeValues}
                                            value={this.state.search_by}
                                        >
                                            {searchBy.map((search) => (
                                                <option
                                                    key={search.value}
                                                    value={search.value}
                                                >
                                                    Search By {search.key}
                                                </option>
                                            ))}
                                        </select>
                                        
                                        {this.state.search_by =='lock_status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {lockStatusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by =='StoreType' &&<select
                                    className="form-control"
                                    style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                    name="search_key"
                                    onChange={this.onChangeValues}
                                    value={this.state.search_key}
                                    >
                                    {StoreTypeArray.map((search) => (
                                        <option
                                            key={search.value}
                                            value={search.value}
                                        >
                                            {search.key}
                                        </option>
                                    ))}
                                    </select>}
                                    {this.state.search_by !=='lock_status' && this.state.search_by !=='StoreType' &&<Form.Control
                                            style={{
                                                marginLeft: '1rem',
                                                marginRight: '1rem',
                                                width: 'auto'
                                            }}
                                            placeholder="Search key"
                                            type="text"
                                            name="search_key"
                                            value={this.state.search_key}
                                            onChange={this.onChangeValues}
                                        />}
                                        <Button
                                            variant="primary"
                                            onClick={this.submitSearch}
                                        >
                                            Search
                                        </Button>

                                        <Button
                                            style={{ marginLeft: '1rem' }}
                                            variant="primary"
                                            onClick={this.restSearch}
                                        >
                                            Reset
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <MaterialTable
                                title="Store Tags"
                                columns={[
                                    {
                                        title: 'StoreTag',
                                        field: 'StoreTag',
                                        render: (row) => (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'blue'
                                                }}
                                                onClick={(e) =>
                                                    this.showEditItem(row)
                                                }
                                            >
                                                {row.StoreTag}
                                            </div>
                                        )
                                    },
                                    { title: 'Email-Id', field: 'EmailId' },

                                    {
                                        title: 'Store-CP',
                                        field: 'StoreCPNameView',
                                        render: (row) => (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'blue'
                                                }}
                                                onClick={(e) =>
                                                    this.showViewProfile(
                                                        row.StoreCPName,
                                                        row.StoreCP,
                                                        'StoreCP'
                                                    )
                                                }
                                            >
                                                {row.StoreCPName}
                                            </div>
                                        )
                                    },
                                    {
                                        title: 'Employee',
                                        field: 'EmployeeNameView',
                                        render: (row) => (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'blue'
                                                }}
                                                onClick={(e) =>
                                                    this.showViewProfile(
                                                        row.EmployeeName,
                                                        row.Employee,
                                                        'Employees'
                                                    )
                                                }
                                            >
                                                {row.EmployeeName}
                                            </div>
                                        )
                                    },
                                    {
                                        title: 'Distributor',
                                        field: 'DistributorNameView',
                                        render: (row) => (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'blue'
                                                }}
                                                onClick={(e) =>
                                                    this.showViewProfile(
                                                        row.DistributorName,
                                                        row.Distributor,
                                                        'Distributor'
                                                    )
                                                }
                                            >
                                                {row.DistributorName}
                                            </div>
                                        )
                                    },
                                    {
                                        title: 'StoreOwner',
                                        field: 'StoreOwnerNameView',
                                        render: (row) => (
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    color: 'blue'
                                                }}
                                                onClick={(e) =>
                                                    this.showViewProfile(
                                                        row.StoreOwnerName,
                                                        row.StoreOwner,
                                                        'StoreOwners'
                                                    )
                                                }
                                            >
                                                {row.StoreOwnerName}
                                            </div>
                                        )
                                    }
                                ]}
                                data={this.state.data}
                                actions={actions}
                                options={{
                                    exportButton: {
                                        csv: true
                                    },
                                    filtering: false,
                                    search: false,
                                    sorting: false,
                                    paging: false,

                                    actionsColumnIndex: -1
                                }}
                            />

                            <div>
                                <hr />
                            </div>
                            <Row className="custom_pagination">
                                {this.state.StartAt.length > 1 && (
                                    <Col>
                                        <Button
                                            onClick={this.paginatePrev}
                                            variant="primary"
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}
                                {this.state.StartAt.length < 2 && (
                                    <Col>
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}

                                <Col style={{ textAlign: 'center' }}>
                                    {'Items per page:'}
                                    <select
                                        className="items_per_page"
                                        onChange={this.handlePageSizeChange}
                                        value={this.state.perPage}
                                    >
                                        {pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>
                                    Page: {this.state.StartAt.length}
                                </Col>

                                <Col style={{ textAlign: 'right' }}>
                                    {this.state.data.length <
                                        this.state.perPage && (
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Next
                                        </Button>
                                    )}

                                    {this.state.data.length >=
                                        this.state.perPage && (
                                        <Button
                                            onClick={this.paginateNext}
                                            variant="primary"
                                        >
                                            Next
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    )}

                {this.state.showEdit && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleAction}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Store Tag Information
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <StoretagProfileDetail
                            selectedRow={this.state.selectedRow}
                            {...this.props}
                        />
                    </div>
                )}

                {this.state.showAdd && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleAction}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Store Tag Information
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <AddEdit
                            selectedRow={this.state.selectedRow}
                            {...this.props}
                        />
                    </div>
                )}

                {this.state.importExport && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleImportExport}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Import Store Tags
                            </h4>
                        </Row>
                        <ImportExport {...this.props} />
                    </div>
                )}

                {this.state.viewProfile && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.cancleviewProfile}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Profile Detail
                            </h4>
                        </Row>
                        <ViewProfileDetail
                            profileFullName={this.state.profileFullName}
                            selectedUserRole={this.state.viewProfileRole}
                            UniqeID={this.state.UniqeID}
                            {...this.props}
                        />
                    </div>
                )}
            </Container>
        );
    }
}

export default withFirebase(AllList);
